import api from './api';
import types from './mutation-types';
import _ from 'lodash';

export default {
	setExcelPopParam_({ commit }, { key, value }) {
		commit(types.EXCEL_POUPUP_PARAM, { key, value });
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setSelectedRowInit_({ commit }) {
		commit(types.SELECTED_ROW_INIT);
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	getPowTourPrvsMngManagements_({ commit, state }) {
		const { searchParams, pagingInfo } = state;

		return api
			.getPowTourPrvsMngManagements({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'powTourPrvsMngManagements',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPowTourPrvsMngManagement_({ commit }, param) {
		//alert("액션")
		return api
			.postPowTourPrvsMngManagement(param)
			.then(data => {
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			//return error?.header;
			throw new Error(error?.header);
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce_({ commit }) {
		try {
			function sortCommCdList(commCd, val) {
				const key = _.camelCase(commCd) + 'CdList';
				const list = [];
				val.length && val.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				commit(types.DEFAULT_ASSIGN, { key, value: list });
			}
			const { header, body } = await api.getCommCodesOnce();
			if (header.code === 0) {
				for (const [key, val] of Object.entries(body)) {
					sortCommCdList(key, val);
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async setPowPrvsCdList_({ state, dispatch }) {
		const { powLnCd } = state.selectedRow;
		const key = 'powPrvsCdList';
		await dispatch('getCommCodes_', { key, codeType: powLnCd });
	},
	async setAllPowPrvsCdList_({ state, commit }) {
		const codes = state.occuPlCdList?.map(cd => cd.value)?.join(',');
		const { body } = await api.getMergedCommCodesOnce(codes);
		commit(types.DEFAULT_ASSIGN, { key: 'allPowPrvsCdList', value: body });
	}
};
